<template>
  <gj-log-table
      :adapt-height="false"
      :height="360"
      :params="{
        model: {shipNoteId: id}
      }"
      url="/supply/shipNoteLog/logPage"
      :columns="columns"
  ></gj-log-table>
</template>

<script>
  import {queryMixin} from "../../../../../minxins";
  import {logOpType} from "../../../warehouse/inventory/enum";

  export default {
    name: "app-shipment-bill-log",
    mixins: [queryMixin],
    props: {
      id: null,
    },
    data() {
      return {
        columns: [
          {id: 'op', header: '操作分类', field: 'option:op', minWidth: '120px', options: logOpType},
          {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'},
          {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
          {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '130px'}
        ],
      }
    }
  }
</script>

<style scoped>

</style>
